/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PutApiV1PersonIdFinancialDataMutationRequest,
  PutApiV1PersonIdFinancialDataMutationResponse,
  PutApiV1PersonIdFinancialDataPathParams,
  PutApiV1PersonIdFinancialData400,
  PutApiV1PersonIdFinancialData401,
  PutApiV1PersonIdFinancialData404,
  PutApiV1PersonIdFinancialData500,
} from "../../types/personFinancialController/PutApiV1PersonIdFinancialData.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { putApiV1PersonIdFinancialData } from "../../clients/personFinancialController/putApiV1PersonIdFinancialData.ts";

export const putApiV1PersonIdFinancialDataMutationKey = () =>
  [{ url: "/api/v1/person/:id/financial-data" }] as const;

export type PutApiV1PersonIdFinancialDataMutationKey = ReturnType<
  typeof putApiV1PersonIdFinancialDataMutationKey
>;

export function putApiV1PersonIdFinancialDataMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<PutApiV1PersonIdFinancialDataMutationRequest>
  > & { client?: Client } = {},
) {
  const mutationKey = putApiV1PersonIdFinancialDataMutationKey();
  return mutationOptions<
    PutApiV1PersonIdFinancialDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdFinancialData400
      | PutApiV1PersonIdFinancialData401
      | PutApiV1PersonIdFinancialData404
      | PutApiV1PersonIdFinancialData500
    >,
    {
      id: PutApiV1PersonIdFinancialDataPathParams["id"];
      data?: PutApiV1PersonIdFinancialDataMutationRequest;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return putApiV1PersonIdFinancialData(id, data, config);
    },
  });
}

/**
 * @description Atualiza a aba Financial. Cria o PersonFinancial caso ainda não exista. Todos os campos informados sobrescrevem os atuais. **(Requer Authorization para autenticação)**
 * @summary Atualizar dados financeiros (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/financial-data}
 */
export function usePutApiV1PersonIdFinancialData<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiV1PersonIdFinancialDataMutationResponse,
      ResponseErrorConfig<
        | PutApiV1PersonIdFinancialData400
        | PutApiV1PersonIdFinancialData401
        | PutApiV1PersonIdFinancialData404
        | PutApiV1PersonIdFinancialData500
      >,
      {
        id: PutApiV1PersonIdFinancialDataPathParams["id"];
        data?: PutApiV1PersonIdFinancialDataMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PutApiV1PersonIdFinancialDataMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiV1PersonIdFinancialDataMutationKey();

  const baseOptions = putApiV1PersonIdFinancialDataMutationOptions(
    config,
  ) as UseMutationOptions<
    PutApiV1PersonIdFinancialDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdFinancialData400
      | PutApiV1PersonIdFinancialData401
      | PutApiV1PersonIdFinancialData404
      | PutApiV1PersonIdFinancialData500
    >,
    {
      id: PutApiV1PersonIdFinancialDataPathParams["id"];
      data?: PutApiV1PersonIdFinancialDataMutationRequest;
    },
    TContext
  >;

  return useMutation<
    PutApiV1PersonIdFinancialDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdFinancialData400
      | PutApiV1PersonIdFinancialData401
      | PutApiV1PersonIdFinancialData404
      | PutApiV1PersonIdFinancialData500
    >,
    {
      id: PutApiV1PersonIdFinancialDataPathParams["id"];
      data?: PutApiV1PersonIdFinancialDataMutationRequest;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PutApiV1PersonIdFinancialDataMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdFinancialData400
      | PutApiV1PersonIdFinancialData401
      | PutApiV1PersonIdFinancialData404
      | PutApiV1PersonIdFinancialData500
    >,
    {
      id: PutApiV1PersonIdFinancialDataPathParams["id"];
      data?: PutApiV1PersonIdFinancialDataMutationRequest;
    },
    TContext
  >;
}
